import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useWallet } from "../hooks/useWallet";

export function ProtectedRoute({ children }) {
  const { isConnected, isInitializing, jwtToken } = useWallet();
  const location = useLocation();

  if (isInitializing) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-gray-500">Initializing...</div>
      </div>
    );
  }

  if (!isConnected || !jwtToken) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}
